module.exports = __webpack_public_path__ + "0af5d249/img/revit-icon.5ff0d581.svg";